<template>
  <div class="space-y-12 flex flex-col text-gray_light pb-16">
    <Logo class="self-center text-left mt-6 w-64 cursor-pointer" @click="$router.go(-1)"/>

    <a href="/login" class="mt-6 underline">Ya tengo cuenta</a>
    <!--    <div v-if="latitude || longitude" >-->
<!--      <p class="mx-24 font-light">{{ latitude + '/' + longitude }}</p>-->
<!--    </div>-->
<!--    <p v-if="!latitude || !longitude" class="mx-24 font-light">Es necesario activar la geolocalizacion para mejorar la experiencia de usuario</p>-->
    <div class="space-y-3 w-full">
      <p class="mx-4 font-light">Añade los datos de tu restaurante</p>

      <div class="flex flex-col w-full px-4 text-black">
        <input
          type="text"
          placeholder="Dirección *"
          :value="address"
          @input="$emit('update:address', $event.target.value)"
          class="border rounded-md px-4 py-2 w-full">
      </div>
      <div class="flex gap-2 w-full px-4 text-black">
        <input
          type="text"
          placeholder="Ciudad"
          :value="city"
          @input="$emit('update:city', $event.target.value)"
          class="border rounded-md px-4 py-2 flex-1">
        <input
          type="text"
          placeholder="Estado/Provincia/Región"
          :value="state"
          @input="$emit('update:state', $event.target.value)"
          class="border rounded-md px-4 py-2 flex-1 disabled:bg-gray_light">
<!--        <select id="companionSelectorSS" class="flex-1 border p-1 rounded-md px-2" v-model="cstate" @change="this.$emit('update:state', $event.target.value)">-->
<!--          <option v-for="province in provinces" :key="province" :value="province.toLowerCase()">{{ province }}</option>-->
<!--        </select>-->
      </div>
      <div class="flex w-full px-4 gap-2 text-black">
        <div class="flex-1 w-full">
          <input
            type="text"
            placeholder="Código postal"
            :value="zip_code"
            @input="$emit('update:zip_code', $event.target.value)"
            class="border rounded-md py-2">
        </div>
        <SearchSelect
          class="flex-1 custom-search-input"
          :country_iso="country_iso"
          style="border-radius: 6px !important;"
          :same-address-input="false"
          @selected-country="setCountry"/>
      </div>
    </div>
    <div v-if="confirmation" class="text-red text-left">
      Por favor Agregue la dirección
    </div>
  </div>
</template>

<script>
import Logo from '@/components/logos/logo-white'
import SearchSelect from '@/components/ui/SearchSelect'
// TODO ACOMODAR EL LOADER PERPETUO CUANDO NO SE HA INGRESADO LA DIRECCION
export default {
  components: {
    SearchSelect,
    Logo
  },
  props: {
    // latitude: { required: false, type: Number },
    // longitude: { required: false, type: Number },
    address: { required: false, type: String, default: '' },
    city: { required: false, type: String, default: '' },
    state: { required: false, type: String, default: '' },
    zip_code: { required: false, type: String, default: '' },
    country: { required: false, type: String, default: '' },
    country_iso: { required: false, type: String, default: '' },
    confirmation: { required: false, type: Boolean, default: false }
  },
  data () {
    const setCountry = (e) => {
      if (e) {
        this.$emit('update:country', e.text)
        this.$emit('update:country_iso', e.value)
      }
    }
    return {
      cstate: 'madrid',
      provinces: [
        'Albacete', 'Almería', 'Alicante', 'Andorra', 'Asturias', 'Avila', 'Badajoz', 'Barcelona',
        'Bilbao', 'Burgos', 'Cáceres', 'Cádiz', 'Cartagena', 'Castellón', 'Ceuta', 'Ciudad Real',
        'Córdoba', 'Cuenca', 'Elche', 'Gijón', 'Girona', 'Granada', 'Gran Canaria', 'Guadalajara',
        'Huelva', 'Ibiza', 'Jaén', 'La Coruña', 'León', 'Lérida', 'Logroño', 'Madrid', 'Mallorca',
        'Málaga', 'Melilla', 'Menorca', 'Murcia', 'Navarra', 'Oviedo', 'Palencia', 'Pamplona',
        'Pontevedra', 'Salamanca', 'San Sebastián', 'Santander', 'Segovia', 'Sevilla', 'Soria',
        'Tarragona', 'Tenerife', 'Teruel', 'Toledo', 'Valencia', 'Valladolid', 'Vigo', 'Zamora', 'Zaragoza'
      ],
      setCountry
    }
  },
  methods: {
    // validateZipcode (e) {
    //   const numberRegex = /^[A-Z0-9]{1,4}[ -]?[A-Z0-9]{1,4}([ -]?[A-Z0-9]{1,4})?$/
    //   console.log(e.target.value)
    //   console.log(numberRegex.test(e.key))
    //   if (!numberRegex.test(e.target.value)) {
    //     this.$emit('update:zip_code', e.target.value)
    //   } else {
    //     e.preventDefault()
    //     // const aux = this.newPhone.replace(/\D/g, '')
    //   }
    // }
  },
  mounted () {
    this.cstate = this.state
  }
}
</script>
